import { getIndustryApi } from "@/api/services/admin/learning-content";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useQuery } from "@tanstack/react-query";

/**
 * Custom hook for fetching industry detail by ID
 * Uses React Query for caching and automatic refetching
 */
export const useIndustryDetail = (industryId?: string) => {
  const isValidId = Boolean(industryId) && /^\d+$/.test(industryId!);

  const query = useQuery({
    queryKey: [QUERY_KEYS.LEARNING_CONTENT.FETCH_DETAIL, industryId],
    queryFn: () => getIndustryApi(industryId!),
    enabled: isValidId,
  });

  return {
    data: query.data?.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
